import React from 'react';

import { t } from '../../services/i18nService';
import navigationService from '../../services/NavigationService';
import sessionReader from '../../store/readHelpers/SessionReader';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';

import styles from './options.scss';

class OptionsExitSeb extends React.PureComponent {
    actionHandler = () => {
        navigationService.exitSeb();
    };

    render() {
        const mainButtonText = t('options.exitSebButtonText');
        const requireInvigilatorPassword = sessionReader.testUsesInvigilatorPassword();

        return (
            <div>
                <OptionsTopBar title={t('options.exitSeb')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        mainButtonText={mainButtonText}
                        actionHandler={this.actionHandler}
                        requireInvigilatorPassword={requireInvigilatorPassword}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsExitSeb;
